import React, { Component } from 'react';
import Wrapper from '../common/Wrapper';
import { MenuItem} from 'react-bootstrap'
import history from '../../history';
import PropTypes from 'prop-types'
import { routesUrls } from '../../settings/routes';
import Presentations from '../Presentations/Presentations';

class CustomItems extends Component {
  static contextTypes = {formatMessage: PropTypes.any}
  render() {
    const {formatMessage} = this.context;
    return <React.Fragment>
      <MenuItem
        onClick={() => {
          history.push(routesUrls.dashboard)
        }}
      >{formatMessage('navTitleDashboard')}</MenuItem>
   </React.Fragment>
  }
}

const PresentationsPage = () => {
  return <Wrapper 
    renderButtonNav = {false}
    CustomItems={CustomItems}
  >
    <Presentations />
  </Wrapper>
}

export default PresentationsPage;



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/routes/PresentationsPage.js